import { pickBy } from 'lodash';

const slots = [
  {
    type: 'Slot',
    moneyNode: false,
    cascade: false,
    paylines: true,
  }, {
    type: 'CashPot',
    moneyNode: false,
    cascade: false,
    paylines: false,
  }, {
    type: 'Cascade',
    moneyNode: true,
    cascade: true,
    paylines: false,
  }, {
    type: 'CascadeMultiplier',
    moneyNode: true,
    cascade: true,
    paylines: false,
  }, {
    type: 'CollectPots',
    moneyNode: true,
    cascade: false,
    paylines: true,
  }, {
    type: 'Fortune',
    moneyNode: true,
    cascade: false,
    paylines: true,
  }, {
    type: 'InvertPots',
    moneyNode: true,
    cascade: false,
    paylines: true,
  }, {
    type: 'Core',
    moneyNode: false,
    cascade: false,
    paylines: false,
  }, {
    type: 'Mines',
    moneyNode: true,
    cascade: false,
    paylines: false,
  }, /*  {
    type: 'ScoreCompare',
    moneyNode: true,
    cascade: false,
    paylines: false,
  }, */
];

/* eslint-disable arrow-body-style */
export const isSlot = (gameType) => {
  return slots.some((slot) => slot.type === gameType);
};

export const isNewSlot = (gameType) => {
  return gameType !== 'Slot' && slots.some((slot) => slot.type === gameType);
};

export const isCascadeSlot = (gameType) => {
  return slots.some((slot) => slot.type === gameType && slot.cascade);
};

export const isMoneyNodeSlot = (gameType) => {
  return slots.some((slot) => slot.type === gameType && slot.moneyNode);
};

export const isSlotWithPaylines = (gameType) => {
  return slots.some((slot) => slot.type === gameType && slot.paylines);
};

export const groupToSlot = (gameType) => {
  return slots.some((slot) => slot.type === gameType) ? 'Slot' : gameType;
};

export const getAllGameTypes = () => {
  return [
    {
      type: 'Roulette',
      moneyNode: false,
      cascade: false,
      paylines: false,
    },
    {
      type: 'Slingshot',
      moneyNode: false,
      cascade: false,
      paylines: false,
    },
    {
      type: 'PrizeDrop',
      moneyNode: false,
      cascade: false,
      paylines: false,
    },
    ...slots,
  ];
};

const perLineFields = {
  minBet: 'minBetPerLineAmount',
  maxBet: 'maxBetPerLineAmount',
  maxWin: 'maxWinPerLineAmount',
};

const totalFields = {
  minBet: 'minBetAmount',
  maxBet: 'maxBetAmount',
  maxWin: 'maxWinAmount',
};

// tenant limits are entered once per currency, but stored per game type:
// per line values for game types with paylines, total values for the rest
export const mapCurrencyLimitsToGameTypes = (currenciesLimits = {}, selectedCurrencies = []) => {
  const gameTypes = {};
  const currencies = Object.keys(currenciesLimits)
    .filter((currency) => selectedCurrencies.includes(currency));

  getAllGameTypes().forEach(({ type, paylines }) => {
    const fields = paylines ? perLineFields : totalFields;
    gameTypes[type] = { currencies: {} };
    currencies.forEach((currency) => {
      const limits = currenciesLimits[currency] || {};
      gameTypes[type].currencies[currency] = pickBy({
        minBetAmount: Number(limits[fields.minBet]) || undefined,
        maxBetAmount: Number(limits[fields.maxBet]) || undefined,
        maxWinAmount: Number(limits[fields.maxWin]) || undefined,
      });
    });
  });

  return gameTypes;
};

export const mapGameTypesToCurrencyLimits = (gameTypes = {}) => {
  const findCurrencies = (hasPaylines) => {
    const match = getAllGameTypes().find(({ type, paylines }) => (
      paylines === hasPaylines && gameTypes?.[type]?.currencies
    ));
    return match ? gameTypes[match.type].currencies : {};
  };
  const withPaylines = findCurrencies(true);
  const withoutPaylines = findCurrencies(false);
  const currencies = new Set([
    ...Object.keys(withPaylines),
    ...Object.keys(withoutPaylines),
  ]);
  const currenciesLimits = {};

  currencies.forEach((currency) => {
    const perLine = withPaylines[currency] || {};
    const total = withoutPaylines[currency] || {};
    currenciesLimits[currency] = {
      [perLineFields.minBet]: perLine.minBetAmount ?? null,
      [perLineFields.maxBet]: perLine.maxBetAmount ?? null,
      [perLineFields.maxWin]: perLine.maxWinAmount ?? null,
      [totalFields.minBet]: total.minBetAmount ?? null,
      [totalFields.maxBet]: total.maxBetAmount ?? null,
      [totalFields.maxWin]: total.maxWinAmount ?? null,
    };
  });

  return currenciesLimits;
};
